import { render, staticRenderFns } from "./mis-datos.vue?vue&type=template&id=19d23fa6&lang=html"
import script from "./mis-datos.vue?vue&type=script&lang=js"
export * from "./mis-datos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports